function Profile() {
  return (
    <>
      <div id="home" className="flex lg:flex-row sm:flex-col  lg:px-8 sm:px-2 lg:mt-20  sm:mt-10 pt-12">
        <div  className="flex justify-center items-center">
          <img src="aqil_black.png" alt="Profile_pic" className=" object-contain sm:h-80 sm:w-80 md:h-80 md:w-80 lg:h-56 lg:w-[54rem]" />
        </div>
        <div className="text-white lg:ml-10 md:ml-20 lg:p-2 sm:p-4 flex flex-col justify-center items-center">
          <h1 className="m-0 text-xl font-bold">Aqil Shahzad</h1>
          <h2 className="m-0 text-xl font-bold mb-5">Software Design Engineer</h2>
          <p className="leading-normal text-medium text-justify ">Experienced Frontend Developer focused on creating user-friendly websites with a sleek and modern look. I love turning ideas into reality using the latest technologies. Let's work together to make your project stand out!</p>
        </div>
      </div>
    </>
  );
}
export default Profile;
